module.exports = __webpack_public_path__ + "static/img/frank.e91d38f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/frank.gif
// module id = 6c3K
// module chunks = 1